import { render, staticRenderFns } from "./LineaParosTurno.vue?vue&type=template&id=4974715a&scoped=true&"
import script from "./LineaParosTurno.vue?vue&type=script&lang=js&"
export * from "./LineaParosTurno.vue?vue&type=script&lang=js&"
import style0 from "./LineaParosTurno.vue?vue&type=style&index=0&id=4974715a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4974715a",
  null
  
)

export default component.exports